import { render, staticRenderFns } from "./EmailsPerDay.vue?vue&type=template&id=a72e1f80"
import script from "./EmailsPerDay.vue?vue&type=script&lang=js"
export * from "./EmailsPerDay.vue?vue&type=script&lang=js"
import style0 from "./EmailsPerDay.vue?vue&type=style&index=0&id=a72e1f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports